import { render, staticRenderFns } from "./feedback-modal.vue?vue&type=template&id=12c86402&"
import script from "./feedback-modal.vue?vue&type=script&lang=js&"
export * from "./feedback-modal.vue?vue&type=script&lang=js&"
import style0 from "./feedback-modal.vue?vue&type=style&index=0&id=12c86402&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports